export const THEME_STORAGE_KEY = 'time-imprint-theme-mode'
export const THEME_MODES = ['system', 'light', 'dark']

export function readThemeMode() {
  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY)
    return THEME_MODES.includes(saved) ? saved : 'system'
  } catch (error) {
    return 'system'
  }
}

export function resolveTheme(mode, prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches) {
  if (mode === 'light' || mode === 'dark') return mode
  return prefersDark ? 'dark' : 'light'
}

export function applyThemeMode(mode = readThemeMode()) {
  const normalizedMode = THEME_MODES.includes(mode) ? mode : 'system'
  const effectiveTheme = resolveTheme(normalizedMode)
  document.documentElement.dataset.theme = effectiveTheme
  document.documentElement.dataset.themeMode = normalizedMode
  return effectiveTheme
}

export function saveThemeMode(mode) {
  const normalizedMode = THEME_MODES.includes(mode) ? mode : 'system'
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, normalizedMode)
  } catch (error) {
    // Keep the current session usable when storage is unavailable.
  }
  applyThemeMode(normalizedMode)
  return normalizedMode
}
